import Quill from "quill";

import { logger } from ".";

export function getHtml(qr: Quill): string {
  const html = qr.getSemanticHTML();
  const s = html.replace(/&nbsp;/gi, " ");
  if (s !== html) {
    logger.trace("Cleaned html", html, "->", s);
  }
  return s;
}
